import { useQuery } from '@tanstack/react-query'

import { GetHestiaPredictionsResponse } from '@api/getHestiaPredictions'

import { SupportedQueryParameters } from '@utils/getAppStateFromQueryParameters'

import { handleApiResponse } from './utils/handleApiResponse'

export const useHestiaPredictionsQuery = ({
    customerId,
}: {
    customerId: SupportedQueryParameters['customerId']
}) => {
    return useQuery<GetHestiaPredictionsResponse>(
        ['hestiaPredictions', customerId],
        () =>
            fetch(
                `${process.env.NEXT_PUBLIC_BASE_PATH}/api/hestia-predictions/?customerId=${customerId}`,
                {
                    method: 'GET',
                }
            ).then(handleApiResponse),
        {
            staleTime: Infinity,
            retry: false,
            refetchOnWindowFocus: false,
            retryOnMount: false,
            enabled: Boolean(customerId),
        }
    )
}
